module.exports = __webpack_public_path__ + "fonts/Inter-700-latin49.260c81a.woff2";